import React from "react";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

const Loader = (props) => {
    const { color, size, ...rest } = props;
    return (
        <Box sx={{ display: 'flex' }} {...rest}>
            <CircularProgress color={color} size={size} />
        </Box>
    )
}

Loader.defaultProps = {
    color: "info",
    size: 40
}

export { Loader };
export default Loader;